import { __decorate, __extends } from "tslib";
import { _GraphQueryableCollection, graphInvokableFactory } from "../graphqueryable";
import { _DirectoryObject, DirectoryObjects } from "../directory-objects/types";
import { defaultPath, updateable, deleteable, getById } from "../decorators";
var _User = /** @class */ (function (_super) {
    __extends(_User, _super);
    function _User() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(_User.prototype, "memberOf", {
        /**
        * The groups and directory roles associated with the user
        */
        get: function () {
            return DirectoryObjects(this, "memberOf");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(_User.prototype, "people", {
        /**
         * Retrieve a collection of person objects ordered by their relevance to the user
         */
        get: function () {
            return People(this);
        },
        enumerable: false,
        configurable: true
    });
    _User = __decorate([
        updateable(),
        deleteable()
    ], _User);
    return _User;
}(_DirectoryObject));
export { _User };
export var User = graphInvokableFactory(_User);
var _Users = /** @class */ (function (_super) {
    __extends(_Users, _super);
    function _Users() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    _Users = __decorate([
        defaultPath("users"),
        getById(User)
    ], _Users);
    return _Users;
}(_GraphQueryableCollection));
export { _Users };
export var Users = graphInvokableFactory(_Users);
var _People = /** @class */ (function (_super) {
    __extends(_People, _super);
    function _People() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    _People = __decorate([
        defaultPath("people")
    ], _People);
    return _People;
}(_GraphQueryableCollection));
export { _People };
export var People = graphInvokableFactory(_People);
//# sourceMappingURL=types.js.map